export default class WorkspacePermissions{

    constructor(){
        this.features={};
        this.rules={};
        this.kino_rules={};
        this.integrations={};
        this.role={};
        this.user=USER_ID;
        this.allow_join=ALLOW_JOIN;
        this.verified_member=(IS_VERIFIED_MEMBER == 1);
        this.isHost=HOST == 1;
        this.space_id = SPACE_ID;
        this.addons = [];
    }

    setPermissions({features,role_rules,kino_rules,role,user,integrations,addons}){
        this.features=features;
        this.rules=role_rules;
        this.kino_rules=kino_rules;
        this.role=role;
        this.user=user;
        this.integrations = integrations;
        this.addons = addons;
    }

    setRole(){}

    getRole(){
        return this.role
    }

    canJoinKino(){
        return this.allow_join && this.isVerifiedMember();
    }

    isVerifiedMember(){
        return this.verified_member;
    }

    getKinoRule(ruleName){
        if(this.kino_rules && this.kino_rules.hasOwnProperty(ruleName)){
            return this.kino_rules[ruleName];
        }
        return true
    }

    leaveFallbackAssigned(){
        if(this.kino_rules && this.kino_rules.hasOwnProperty('default_space')){
            return this.kino_rules['default_space'] == 'assigned';
        }
        return false
    }

    initialSpace(){
        return this.space_id ? this.space_id : false;
    }

    shouldRequestToJoin(){
        // if(this.isHost){
        //     return false
        // }
        if(this.getKinoRule('request_to_join')){
            if(this.rules && this.rules.hasOwnProperty('request_to_join')){
                return this.rules.request_to_join;
            }
            return true
        }
        return false;
    }

    shouldMuteChatter(){
        if(this.getKinoRule('mute_chatter')){
            if(this.rules && this.rules.hasOwnProperty('mute_chatter')){
                return this.rules.mute_chatter;
            }
        }
        return false;
    }
    shouldLockChatter(){
        if(this.getKinoRule('lock_chatter')){
            if(this.rules && this.rules.hasOwnProperty('lock_chatter')){
                return this.rules.lock_chatter;
            }
            return true;
        }
        return false;
    }
    shouldLockSpaces(){
        if(this.getKinoRule('lock_spaces')){
            if(this.rules && this.rules.hasOwnProperty('lock_spaces')){
                return this.rules.lock_spaces;
            }
            return true;
        }
        return false;
    }
    shouldMuteMicrophone(){
        if(this.getKinoRule('mute_microphones')){
            if(this.rules && this.rules.hasOwnProperty('mute_microphones')){
                return this.rules.mute_microphones;
            }
        }
        return false;
    }

    shouldRequestToJoinPrivateSpace(){
        if(this.getKinoRule('join_private_spaces')){
            if(this.rules && this.rules.hasOwnProperty('join_private_spaces')){
                return this.rules.join_private_spaces;
            }
            return true
        }
        return false;
    }

    kinoChatterMuteState(){
        if(this.kino_rules && this.kino_rules.hasOwnProperty('mute_chatter')){
            return this.kino_rules.mute_chatter;
        }
        return false;
    }

    kinoChatterLockState(){
        if(this.kino_rules && this.kino_rules.hasOwnProperty('lock_chatter')){
            return this.kino_rules.lock_chatter;
        }
        return false;
    }

    kinoSpacesLockState(){
        if(this.kino_rules && this.kino_rules.hasOwnProperty('lock_spaces')){
            return this.kino_rules.lock_spaces;
        }
        return false;
    }
    //workspace check features
    hasChat(){
        if(this.features && this.features.hasOwnProperty('show_chat')){
            return this.features.show_chat;
        }
        return false
    }
    hasWave(){
        if(this.features && this.features.hasOwnProperty('wave')){
            return this.features.wave;
        }
        return false
    }
    hasSpacesManager(){
        if(this.features && this.features.hasOwnProperty('spaces_manager')){
            return this.features.spaces_manager;
        }
        return false
    }
    hasDragDropSpaces(){
        if(this.features && this.features.hasOwnProperty('drag_drop_spaces')){
            return this.features.drag_drop_spaces;
        }
        return false
    }
    isLockedToSpace(){
        if(this.features && this.features.hasOwnProperty('locked_to_space')){
            return this.features.locked_to_space;
        }
        return false
    }
    hasStageView(){
        if(this.features && this.features.hasOwnProperty('stage_view')){
            return this.features.stage_view;
        }
        return false
    }
    hasAnnouncer(){
        if(this.features && this.features.hasOwnProperty('announcer')){
            return this.features.announcer;
        }
        return false
    }
    hasKinoTimer(){
        if(this.features && this.features.hasOwnProperty('kino_timer')){
            return this.features.kino_timer;
        }
        return false
    }
    hasSpacesLock(){
        if(this.features && this.features.hasOwnProperty('lock_spaces')){
            return this.features.lock_spaces;
        }
        return false
    }
    hasPrivateSpaces(){
        if(this.features && this.features.hasOwnProperty('private_spaces')){
            return this.features.private_spaces;
        }
        return false
    }
    hasMuteAll(){
        if(this.features && this.features.hasOwnProperty('mute_microphones')){
            return this.features.mute_microphones;
        }
        return false
    }
    hasMuteLock(){
        if(this.features && this.features.hasOwnProperty('lock_microphones')){
            return this.features.lock_microphones;
        }
        return false
    }
    hasAddSpaces(){
        if(this.features && this.features.hasOwnProperty('create_spaces')){
            return this.features.create_spaces;
        }
        return false
    }
    hasChatterLock(){
        if(this.features && this.features.hasOwnProperty('lock_chatter')){
            return this.features.lock_chatter;
        }
        return false
    }
    hasMuteChatter(){
        if(this.features && this.features.hasOwnProperty('mute_chatter')){
            return this.features.mute_chatter;
        }
        return false
    }
    hasShareScreen(){
        if(this.features && this.features.hasOwnProperty('share_screen')){
            return this.features.share_screen;
        }
        return false
    }
    hasInvite(){
        return false
    }
    hasShowTheDoor(){
        if(this.features && this.features.hasOwnProperty('show_the_door')){
            return this.features.show_the_door;
        }
        return false
    }
    hasChangeVolume(){
        if(this.features && this.features.hasOwnProperty('change_volume')){
            return this.features.change_volume;
        }
        return false
    }
    hasControlSpacesVolume(){
        if(this.features && this.features.hasOwnProperty('control_spaces_volume')){
            return this.features.control_spaces_volume;
        }
        return false
    }
    hasKinoRecorder(){
        if(this.features && this.features.hasOwnProperty('kino_recorder')){
            return this.features.kino_recorder;
        }
        return false
    }
    hasLiveStreaming(){
        if(this.features && this.features.hasOwnProperty('live_streaming')){
            return this.features.live_streaming;
        }
        return false
    }
    canAcceptUsers(){
        if(this.features && this.features.hasOwnProperty('accept_users')){
            return this.features.accept_users;
        }
        return false;
    }

    isTeamsIntegrationEnabled(){
        if(this.integrations && this.integrations.hasOwnProperty('microsoft_teams_integration')){
            return this.integrations.microsoft_teams_integration;
        }
        return false;
    }

    hasTeamsIntegrationAddon(){
        const addon = this.addons.find(a=>a.feature_name.replace(" ","-").toLowerCase() === "microsoft-teams-integration");
        if(addon){
            return true;
        }
        return false
    }
};
